"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * TODO
 * adding other field types
 */
var _default = {
  ADDRESS_PICKLIST: 'address-picklist',
  LANGUAGE_PICKLIST: 'language-picklist',
  EMAIL: 'email',
  TEXT: 'text',
  TEXT_AREA: 'textarea',
  SELECT: 'select',
  DATE_PICKER: 'date-picker',
  TIME_PICKER: 'time-picker',
  S3_UPLOAD: 's3-upload',
  CHECKBOX: 'checkbox',
  CHECKBOX_GROUP: 'checkbox-group',
  RADIO: 'radio',
  TILED_RADIO: 'tiled-radio',
  TILED_CHECKBOX_GROUP: 'tiled-checbkox-group',
  READ_ONLY: 'readonly',
  HIDDEN: 'hidden',
  NUMBER: 'number',
  WHOLE_NUMBER: 'whole-number'
};
exports.default = _default;
//# sourceMappingURL=ConfigFormTypes.js.map